
/* eslint-disable */
import React, { useEffect, useState } from 'react'
import { DropDownList, MultiSelect } from '@progress/kendo-react-dropdowns';
import { Field, Form, FormElement } from '@progress/kendo-react-form';
import { Expander } from '../platformLayout/tv/Dashboard/helperComponent/ExpandableTile';
import { useLocation, useNavigate } from 'react-router-dom';
import * as API from "../../framework/API/api"
import { ENTITYNAME, MEDIACATEGORIES, TOAST_TYPES } from '../../framework/constant/constant';
import { Checkbox } from '@progress/kendo-react-inputs';
import CollectionSelection from '../../framework/forms/CollectionSelection';
import { TimePickerWithFormat } from '../../framework/forms/helpercomponents/timepicker/TimePickerWithFormat';
import { utility } from '../../framework/utility/utilityProvider';
import { useTranslation } from '../../locale/useTranslation';
import SaveButton from '../../framework/forms/helpercomponents/buttons/SaveButton';
import CancelButton from '../../framework/forms/helpercomponents/buttons/CancelButton';
import InfoRoundButton from '../../components/InfoRoundButton';
import { ContentEditForm } from '../masters/ContentEditForm';
import { history } from '../../components/history';
import LanguageTranslator from '../../components/LanguageTranslator';
import { GenreEditForm } from '../masters/GenreEditForm';
import { ConfirmAlert } from '../../ConfirmAlert';
import RoundButton from '../../framework/forms/helpercomponents/buttons/RoundButton';
import MMImageEditForm from './MMImageEditForm';
import ImageCard from './component/ImageCard';
import BossDialog from '../../components/BossDialog';
import TooltipInfoCard from '../../components/TooltipInfoCard';
import AddRoundButton from '../../framework/forms/helpercomponents/buttons/AddRoundButton';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import DeleteRoundButton from '../../framework/forms/helpercomponents/buttons/DeleteRoundButton';
import { TimeCell } from '../../framework/forms/helpercomponents/CustomGridCells/TimeCell';
import MediaSubCategoryTypeEditForm from '../masters/MediaSubCategoryTypeEditForm';
import ToastNotification from '../../components/ToastNotification';

const AddProgramWrapperForm = (props) => {

    const lang = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();

    const [dataItem, setDataItem] = useState({ SID: 0 });
    const [content, setContent] = useState([]);
    const [seasonContent, setSeasonContent] = useState([]);
    const [episodeContent, setEpisodeContent] = useState([]);
    const [openImageBank, setOpenImageBank] = useState(false);
    const [openSeriesSelection, setOpenSeriesSelection] = useState(false);
    const [disableEpsiodeFields, setDisableEpsiodeFields] = useState(true);
    const [mediaSubCategoryType, setMediaSubCategoryType] = useState([]);
    const [showTranslateForm, setShowTranslateForm] = useState(false);
    const [genres, setGenres] = useState([]);
    const [currentUserChannels, setCurrentUserChannels] = useState([]);
    const [selectedSeries, setSelectedSeries] = useState({});
    const [isArchiveChanged, setIsArchiveChanged] = useState(false);

    const [createEpisodeDataItem, setCreateEpisodeDataItem] = useState({});
    const [seasonEpisodeDataItem, setSeasonEpisodeDataItem] = useState({});
    const [createSeasonEpisode, setCreateSeasonEpisode] = useState([]);

    const defaultFormState = {
        Content: false,
        MediaSubCategoryType: false
    }
    const [showEditForm, setShowEditForm] = useState(defaultFormState);

    useEffect(() => {
        loadcombo();
    }, []);




    const loadcombo = async (onlyMaster = false) => {
        let mediaSubCategoryTypeRes = await API.getDataLookup(ENTITYNAME.MediaSubCategoryType, { sort: { SID: 1 } });
        setMediaSubCategoryType(mediaSubCategoryTypeRes.data);
        let contentRes = await API.getDataLookup(ENTITYNAME.Content, { sort: { Description: 1 }, query: ['Archive', '=', false] });
        setContent(contentRes.data);
        let genresRes = await API.getDataLookup(ENTITYNAME.Genre, { sort: { Description: 1 } });
        setGenres(genresRes.data);

        let userChannels = await utility.getUserChannels()
        setCurrentUserChannels(userChannels);

        setCreateEpisodeDataItem({
            NumberOfEpisodes: 1,
            Content: content.find((x) => x.MediaCategoryType.MediaCategorySID == MEDIACATEGORIES.Episode) ?? {},
            StartingEpisodes: 1,
            Duration: "00:00:00:00",
        })

        if (!onlyMaster) {
            setDataItem({
                ...dataItem,
                MediaSubCategoryType: mediaSubCategoryTypeRes.data[0],
                Genres: utility.getDefaultItems(genresRes.data),
                SubGenres: utility.getDefaultItems(genresRes.data)
            })
        }

    }

    const onChange = async (e) => {

        if (e.target.name == "Content") {

            let item = { ...dataItem, Content: e.target.value }
            const updatedContent = await API.getAndSaveNextNumber(e.target.value.SID, { ...e.target.value, isSaveNextnumber: false });
            if (!updatedContent.success) return;
            console.log(!updatedContent.success);

            setDataItem({ ...item, AssetId: updatedContent.data.HouseNumber });

        } else if (e.target.name == "Title") {
            setDataItem({ ...dataItem, Title: e.target.value, Description: e.target.value });
        } else if (e.target.name == "CustomTitle1" || e.target.name == "CustomTitle2") {
            let name = e.target.name == "CustomTitle1" ? "Title1" : "Title2";
            setDataItem({ ...dataItem, CustomTitle: { ...dataItem.CustomTitle, [name]: e.target.value } });
        } else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }

        if (e.target.name == "Archive") {
            console.log(!isArchiveChanged);
            setIsArchiveChanged(!isArchiveChanged)
        }
    };

    const handleCreateEpisodeChange = (e) => {
        setCreateEpisodeDataItem({ ...createEpisodeDataItem, [e.target.name]: e.target.value });

        if (e.target.name == "NumberOfEpisodes") {
            if (e.target.value > 0) {
                setDisableEpsiodeFields(() => false);
            } else {
                setDisableEpsiodeFields(() => true);
            }
        }
    };

    const handleCreateSeasonEpisodeChange = (e) => {
        setSeasonEpisodeDataItem({ ...seasonEpisodeDataItem, [e.target.name]: e.target.value });
    }

    const onSelectionSeries = (dataList) => {
        console.log(dataList);
        setSelectedSeries(() => dataList[0]);
        setDataItem({ ...dataItem, ["Series_Id"]: dataList[0]._id });
    }

    const onCancelEdit = () => {
        if (dataItem.SID == 0) {

            if (location.state.selectedSeries) {
                history.replace(`/home/MediaEpisode/Series/${location.state.selectedSeries.SID}`, { state: { quickEdit: false, copy: false } })
                navigate(-1);
            } else {
                navigate(-1);
            }

            setFormOpen(false);
        } else if (props.isManageContent) {
            props.onCancelEdit();
        } else {
            props.quickEdit ? navigate(-1) : setFormOpen(false);
        }
    }

    async function validationCheck() {


        if (dataItem.Title == '' || dataItem.Title == undefined) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_title_error_message });
            return false;
        }

        if (dataItem.MediaSubCategoryType == undefined || Object.keys(dataItem.MediaSubCategoryType).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_media_sub_category_error_message });
            return false;
        }

        if (dataItem.Description == '' || dataItem.Description == undefined) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_description_error_message });
            return false;
        }

        if (dataItem.MediaSubCategoryType.MediaCategorySID == MEDIACATEGORIES.Season && (dataItem.SeasonNumber < 1 || dataItem.SeasonNumber == undefined)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.season_number_should_not_be_zero_error_message });
            return false;
        }


        if (!dataItem.Content || Object.keys(dataItem.Content).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_content_error_message });
            return false;
        }

        if (dataItem.Genres == undefined || dataItem.Genres.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_genre_error_message });
            return false;
        }

        if (dataItem.MediaSubCategoryType.MediaCategorySID != MEDIACATEGORIES.Season &&
            dataItem.MediaSubCategoryType.MediaCategorySID != MEDIACATEGORIES.Series &&
            (dataItem.Duration == undefined || utility.convertStringTimeToMilliseconds(dataItem.Duration) == 0)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_duration });
            return false;
        }

        if (dataItem.SID == 0 && dataItem.MediaSubCategoryType.MediaCategorySID == MEDIACATEGORIES.Season) {
            if (createEpisodeDataItem.NumberOfEpisodes < 1 || createEpisodeDataItem.NumberOfEpisodes == undefined) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.number_of_epiosde_should_not_be_zero_error_message });
                return false;
            }
            if (Object.keys(createEpisodeDataItem.Content).length == 0) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_episode_content_error_message });
                return false;
            }
            if (createEpisodeDataItem.StartingEpisodes < 1 || createEpisodeDataItem.StartingEpisodes == undefined) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.starting_epiosde_should_not_be_zero_error_message });
                return false;
            }
            if (createEpisodeDataItem.Duration.includes("_") || createEpisodeDataItem.Duration == '00:00:00:00') {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.invalid_duration_error_message });
                return false;
            }
        }
        return true;
    }

    const onConfirm = async () => {

        console.log("HERE");
        let isValid = await validationCheck();
        if (!isValid) return;

        console.log(dataItem);
        console.log(createEpisodeDataItem);
        console.log(createSeasonEpisode);

        let routeMediaCategory = "Program"
        let state = {
            copy: false,
            quickEdit: false,
            prevPath: location.pathname + `?page=1`,
            paths: [location.pathname],
            pagination: `?page=1`,
            dataItem: dataItem,
            isFromAddProgram: true
        }

        console.log(location.pathname)

        //ROUTE TO SERIES
        switch (dataItem.MediaSubCategoryType.MediaCategorySID) {
            case MEDIACATEGORIES.Series:
                routeMediaCategory = "Series";
                state.createSeasonEpisode = createSeasonEpisode;
                state.prevPath = `/home/MediaEpisode/Series`;
                state.paths = [`/home/MediaEpisode/Series`];

                break;

            case MEDIACATEGORIES.Season:
                routeMediaCategory = "Season";
                state.createEpisodeDataItem = createEpisodeDataItem;
                state.prevPath = `/home/MediaEpisode/Season`;
                state.paths = [`/home/MediaEpisode/Season`];

                break;

            case MEDIACATEGORIES.Movie:
                routeMediaCategory = "Movie";
                state.prevPath = `/home/MediaEpisode/Movie`;
                state.paths = [`/home/MediaEpisode/Movie`];
                break;

            case MEDIACATEGORIES.Program:
                routeMediaCategory = "Program";
                state.prevPath = `/home/MediaEpisode/Program`;
                state.paths = [`/home/MediaEpisode/Program`];
                break;

            default:
                console.log("NO MEDIA SUB CATGEORY TYPE")
                break;
        }


        navigate(`/home/MediaEpisode/${routeMediaCategory}/0?page=1`, { state: state });

    };

    const onCreateMasterClick = (key) => {
        setShowEditForm({
            ...defaultFormState,
            [key]: true
        });
    }

    const handleLangugaeTranslate = (data) => {
        setDataItem({ ...dataItem, Synopsis: data });
        setShowTranslateForm(false);
    }

    const updateReferenceCode = async () => {
        let updateReferenceCode = {
            season_id: dataItem._id,
            SeasonCode: dataItem?.SeasonCode ?? ""
        }
        await API.updateEpisodeReferenceCode(updateReferenceCode);
        props.loadEpisodes(dataItem._id, false);
    }

    const confirAlertUpdateReferenceCode = async () => {
        ConfirmAlert(
            () => { updateReferenceCode() },
            () => { },
            lang.sync_reference_code_message,
            'Are you sure you want to update ?'
        );
    };

    const deleteSeasonDetails = (dataItem) => {
        setCreateSeasonEpisode(createSeasonEpisode.filter((obj) => dataItem.Id != obj.Id))
        ToastNotification({ type: "success", title: lang.success_message_title, message: lang.delete_successfully_grid_data_success_toast_message });
    }

    const MyCommandCell = (props) => (<div>
        <DeleteRoundButton onClick={() => deleteSeasonDetails(props.dataItem)} />
    </div>)

    const onAddSeasonOfSeries = () => {

        if (Object.keys(seasonEpisodeDataItem.SeasonContent).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_season_content_series_error_message });
            return false;
        }
        if (seasonEpisodeDataItem.SeasonNumber == undefined || seasonEpisodeDataItem.SeasonNumber < 1) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.value_is_not_greater_then_zero_season_number_series_error_message });
            return false;
        }
        if (Object.keys(seasonEpisodeDataItem.EpisodeContent).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_epiosde_content_series_error_message });
            return false;
        }
        if (seasonEpisodeDataItem.NumberOfEpisodes == undefined || seasonEpisodeDataItem.NumberOfEpisodes < 1) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.value_is_not_greater_then_zero_episode_number_series_error_message });
            return false;
        }
        if (seasonEpisodeDataItem.Duration.includes("_") || seasonEpisodeDataItem.Duration == '00:00:00:00') {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.invalid_duration_error_message });
            return false;
        }

        if (createSeasonEpisode.length != 0) {
            var checkDuplicate = createSeasonEpisode.filter((obj) => parseInt(obj.SeasonNumber) == parseInt(seasonEpisodeDataItem.SeasonNumber));
            if (checkDuplicate.length != 0) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.entering_same_season_number_twice_series_error_message });
                return;
            }
        }
        setCreateSeasonEpisode([
            ...createSeasonEpisode,
            {
                ...seasonEpisodeDataItem,
                Id: createSeasonEpisode.length + 1,
                Duration: utility.convertStringWithFramesToMilliseconds(seasonEpisodeDataItem.Duration),
                SeasonCode: seasonEpisodeDataItem.SeasonCode + (seasonEpisodeDataItem.SeasonNumber)
            }
        ]);
        setSeasonEpisodeDataItem({
            SeasonNumber: 0,
            NumberOfEpisodes: 0,
            Duration: seasonEpisodeDataItem.Duration,
            EpisodeContent: seasonEpisodeDataItem.EpisodeContent,
            SeasonContent: seasonEpisodeDataItem.SeasonContent,
            SeasonCode: seasonEpisodeDataItem.SeasonCode
        });
    }

    return (
        <div>
            <BossDialog
                title={dataItem?.SID > 0 ? dataItem?.Title : `${lang.create_add_program_dialog_header}`}
                onClose={() => navigate('/home')}
                width={"60%"}
            >
                <div className="row mt-2 mb-2">
                    <div className="marlr ml-4" style={{ display: 'flex' }}>
                        <SaveButton title={"Confirm"} tooltip={"Confirm"} onClick={() => onConfirm()}></SaveButton>
                        <CancelButton onClick={() => navigate('/home')}></CancelButton>

                    </div>
                </div>

                <div className='row'>
                    <div className='col-md-12'>
                        <Form
                            render={(formRenderProps) => (
                                <FormElement>

                                    <div className="row" style={{ margin: "5px" }}>
                                        <div className="col-12 mt-2">
                                            <div className="row">
                                                <div className="form-group col-6">
                                                    <label htmlFor="">{lang.title_label} *</label>
                                                    <input name="Title" type="text" className="form-control form-control-sm" value={dataItem.Title} onChange={(e) => onChange(e)} />
                                                </div>
                                                <div className="form-group col-6">
                                                    <label htmlFor="">{lang.type_label} *</label>
                                                    <div style={{ display: 'flex' }}>
                                                        <DropDownList
                                                            data={mediaSubCategoryType}
                                                            name="MediaSubCategoryType"
                                                            textField="Description"
                                                            dataItemKey="_id"
                                                            value={dataItem.MediaSubCategoryType}
                                                            onChange={onChange}
                                                        />
                                                        <button type="button" title={lang.create_media_subcategory_type_button_tooltip} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary "
                                                            style={{ height: "30px", margin: '0px 0px 0px 5px' }} onClick={() => { onCreateMasterClick('MediaSubCategoryType') }}><i className="fa-solid fa-plus fa-xs"></i>
                                                        </button>
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="row">
                                                <div className="form-group col-6">
                                                    <label htmlFor="">{lang.custom_title_1_label}</label>
                                                    <input name="CustomTitle1" type="text" className="form-control form-control-sm" value={dataItem?.CustomTitle?.Title1} onChange={onChange} />
                                                </div>
                                                <div className="form-group col-6">
                                                    <label htmlFor="">{lang.custom_title_2_label}</label>
                                                    <input name="CustomTitle2" type="text" className="form-control form-control-sm" value={dataItem?.CustomTitle?.Title2} onChange={onChange} />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="form-group col-6">
                                                    <label htmlFor="">{lang.description_label} *</label>
                                                    <input name="Description" type="text" className="form-control form-control-sm" value={dataItem.Description} onChange={(e) => onChange(e)} />
                                                </div>

                                                <div className="col-3">
                                                    <div className="form-group">
                                                        <label htmlFor="TabView">{lang.content_label} *</label>
                                                        <TooltipInfoCard message={lang.used_to_configure_prefix_suffix_and_incremental_next_number_for_assetid_tooltip} />
                                                        <div style={{ display: 'flex' }}>
                                                            <DropDownList
                                                                data={content.filter((x) =>
                                                                    x?.MediaSubCategoryType?.SID == dataItem?.MediaSubCategoryType?.SID
                                                                )}
                                                                name="Content"
                                                                textField="Description"
                                                                dataItemKey="_id"
                                                                value={dataItem.Content}
                                                                onChange={onChange}
                                                                disabled={dataItem.SID > 0 ? true : false}
                                                            />
                                                            <button type="button" title={lang.create_content_button_tooltip} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary "
                                                                style={{ height: "30px", margin: '0px 0px 0px 5px' }} onClick={() => { onCreateMasterClick('Content') }}><i className="fa-solid fa-plus fa-xs"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-3">
                                                    <div className="form-group">
                                                        <label htmlFor="">{lang.asset_id_label}</label>
                                                        <h4>{dataItem.AssetId}</h4>
                                                    </div>
                                                </div>
                                            </div>

                                            {dataItem.MediaSubCategoryType &&
                                                dataItem.MediaSubCategoryType.MediaCategorySID == MEDIACATEGORIES.Season &&
                                                <div className='row'>
                                                    <div className="form-group col-3">
                                                        <label htmlFor="">{lang.season_number_label}</label>
                                                        <input name="SeasonNumber" type="number" className="form-control form-control-sm" value={dataItem.SeasonNumber} onChange={(e) => onChange(e)} />
                                                    </div>
                                                    <div className="form-group col-3" >
                                                        <label htmlFor="">{lang.series_code_label}</label>
                                                        <input name="SeasonCode" style={{ maxWidth: (dataItem.SID > 0 && dataItem?.SeasonCode?.length > 0) && '67%' }} type="text" className="form-control form-control-sm" value={dataItem.SeasonCode} onChange={(e) => onChange(e)} />
                                                        {dataItem.SID > 0 && dataItem?.SeasonCode?.length > 0 && <RoundButton title={lang.sync_reference_code_message} icon="refresh" onClick={confirAlertUpdateReferenceCode} />}
                                                    </div>
                                                    <div className="form-group col-6">
                                                        <label htmlFor="">{lang.hard_disk_label}</label>
                                                        <input name="HardDisk" type="text" className="form-control form-control-sm" value={dataItem?.HardDisk} onChange={onChange} />
                                                    </div>
                                                </div>}
                                            <div className='row'>
                                                <div className="col-6">
                                                    <div className="form-group">
                                                        <label htmlFor="TabView">{lang.genre_label} *</label>
                                                        <div style={{ display: 'flex' }}>
                                                            <MultiSelect
                                                                data={genres}
                                                                name={"Genres"}
                                                                textField="Description"
                                                                dataItemKey="_id"
                                                                value={dataItem.Genres}
                                                                onChange={onChange}
                                                            />
                                                            <button type="button" title={lang.create_genre_button_tooltip} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary "
                                                                style={{ height: "30px", margin: '0px 0px 0px 5px' }} onClick={() => { onCreateMasterClick('Genre') }}><i className="fa-solid fa-plus fa-xs"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-6">
                                                    <div className="form-group">
                                                        <label htmlFor="TabView">{lang.sub_genre_label} </label>
                                                        <div style={{ display: 'flex' }}>
                                                            <MultiSelect
                                                                data={genres}
                                                                name={"SubGenres"}
                                                                textField="Description"
                                                                dataItemKey="_id"
                                                                value={dataItem.SubGenres}
                                                                onChange={onChange}
                                                            />
                                                            <button type="button" title={lang.create_sub_genre_button_tooltip} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary "
                                                                style={{ height: "30px", margin: '0px 0px 0px 5px' }} onClick={() => { onCreateMasterClick('Genre') }}><i className="fa-solid fa-plus fa-xs"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {dataItem.MediaSubCategoryType &&
                                                dataItem.MediaSubCategoryType.MediaCategorySID != MEDIACATEGORIES.Series &&
                                                dataItem.MediaSubCategoryType.MediaCategorySID != MEDIACATEGORIES.Season &&
                                                <div className="row">
                                                    <div className="col-6">
                                                        <div className="form-group">
                                                            <label htmlFor="">{lang.duration_label} *</label>
                                                            <TimePickerWithFormat
                                                                className="form-control form-control-sm"
                                                                name="Duration"
                                                                value={dataItem.Duration}
                                                                onChange={(e) => onChange(e)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="form-group col-6">
                                                        <label htmlFor="">{lang.hard_disk_label}</label>
                                                        <input name="HardDisk" type="text" className="form-control form-control-sm" value={dataItem?.HardDisk} onChange={onChange} />
                                                    </div>

                                                </div>}
                                            {dataItem.MediaSubCategoryType &&
                                                dataItem.MediaSubCategoryType.MediaCategorySID != MEDIACATEGORIES.Movie &&
                                                dataItem.MediaSubCategoryType.MediaCategorySID != MEDIACATEGORIES.Program &&
                                                <div className="form-group">
                                                    <label htmlFor="">{lang.synopsis_label}</label>
                                                    <label className='float-right cursor-pointer' title={lang.translate_synopsis_level} onClick={() => setShowTranslateForm(true)}><i className="fa-solid fa-language" aria-hidden="true"></i></label>
                                                    <textarea type="text" className="form-control form-control-sm" name="Synopsis" value={dataItem.Synopsis} onChange={(e) => onChange(e)} />
                                                </div>}

                                            {dataItem.MediaSubCategoryType &&
                                                dataItem.MediaSubCategoryType.MediaCategorySID == MEDIACATEGORIES.Season &&
                                                <div className="row">
                                                    <div className="form-group col-12">
                                                        <label htmlFor="">{lang.series_label}</label><br />
                                                        <div style={{ display: "flex" }}>
                                                            <input name="Description" type="text" className="d-inline form-control form-control-sm" value={selectedSeries?.Title} onChange={(e) => onChange(e)} disabled={dataItem.SID > 0 ? true : props.disableSelectSeries} />

                                                            <button type="button" title='Create Content' className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary "
                                                                style={{ height: "30px", marginLeft: "10px" }} onClick={() => { setOpenSeriesSelection(true) }} disabled={dataItem.SID > 0 ? true : props.disableSelectSeries}>

                                                                {lang.select_button_text}
                                                            </button>

                                                            <button type="button" title='Create Content' className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary "
                                                                style={{ height: "30px", marginLeft: "10px" }} onClick={() => { setSelectedSeries({ Title: '' }) }} disabled={dataItem.SID > 0 ? true : props.disableSelectSeries}>

                                                                <i className="fa-solid fa-times fa-xs"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>}

                                            <div className="row">
                                                <div className="form-check col-2" style={{ marginBottom: "20px" }}>
                                                    <Field
                                                        style={{ borderColor: "black" }}
                                                        name={"Archive"}
                                                        component={Checkbox}
                                                        label={lang.archive}
                                                        onChange={(e) => onChange(e)}
                                                        checked={dataItem.Archive ? true : false}
                                                    />
                                                </div>

                                                <div className="form-check col-2" style={{ marginBottom: "20px" }}>
                                                    <Field
                                                        style={{ borderColor: "black" }}
                                                        name={"IsLive"}
                                                        component={Checkbox}
                                                        label={lang.islive_label}
                                                        onChange={(e) => onChange(e)}
                                                        checked={dataItem.IsLive ? true : false}
                                                    />
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </FormElement>
                            )}
                        />
                    </div>
                </div>

                {dataItem.MediaSubCategoryType && dataItem.MediaSubCategoryType.MediaCategorySID == MEDIACATEGORIES.Season && <>
                    <p style={{ backgroundColor: "white", paddingLeft: '03px', paddingRight: '03px', marginLeft: '18px', }}>{lang.episodes_label}</p>
                    <div className="row" style={{ border: "solid 1px", padding: "20px", margin: "09px 20px 10px 20px", marginTop: "-15px" }}>

                        <div className='col-6'>
                            <div className="form-group">
                                <label htmlFor="">{lang.no_of_episodes_label}</label>
                                <input name="NumberOfEpisodes" type="number" className="form-control form-control-sm" value={createEpisodeDataItem.NumberOfEpisodes} onChange={(e) => handleCreateEpisodeChange(e)} />
                            </div>
                        </div>

                        <div className="col-6">
                            <div className="form-group">
                                <label htmlFor="TabView">{lang.content_label} *</label>
                                <InfoRoundButton message={lang.used_to_configure_prefix_suffix_and_incremental_next_number_for_assetid_tooltip}></InfoRoundButton>
                                <DropDownList
                                    data={content.filter((x) => x.MediaCategoryType.MediaCategorySID == MEDIACATEGORIES.Episode)}
                                    name="Content"
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={createEpisodeDataItem.Content}
                                    onChange={handleCreateEpisodeChange}
                                    validator={(value) => value ? "" : "Please select value"}

                                />
                            </div>
                        </div>

                        <div className='col-6'>
                            <div className="form-group">
                                <label htmlFor="">{lang.starting_episode_label}</label>
                                <input name="StartingEpisodes" type="number" className="form-control form-control-sm" value={createEpisodeDataItem.StartingEpisodes} onChange={(e) => handleCreateEpisodeChange(e)} />
                            </div>
                        </div>

                        <div className="col-6">
                            <div className="form-group">
                                <label htmlFor="">{lang.duration_label} *</label>
                                <TimePickerWithFormat
                                    className="form-control form-control-sm"
                                    name="Duration"
                                    value={createEpisodeDataItem.Duration}
                                    onChange={(e) => handleCreateEpisodeChange(e)}
                                    required
                                />
                            </div>
                        </div>
                    </div>
                    <p className='text-muted' style={{ fontSize: '11px', position: "relative", top: "20px", left: "15px" }}>{`* ${currentUserChannels && currentUserChannels.length == 1 ? `Deal Rights will automatically be created for ${currentUserChannels[0].FullChannelName}` : "Please create deal rights before saving"}`}</p>
                </>}

                {dataItem.MediaSubCategoryType && dataItem.MediaSubCategoryType.MediaCategorySID == MEDIACATEGORIES.Series && <>
                    <div className='mt-2' style={{ padding: '5px', borderRadius: '8px', backgroundColor: '#F0EBE3' }}>
                        <Expander expand={false} title={lang.season_label} img={dataItem.ImageUrl} color={"#F0EBE3"}>
                            <div className='row mt-1' style={{ border: "solid 1px", padding: "15px", margin: "0px 20px 10px 20px" }}>

                                <div className="col-2">
                                    <label htmlFor="TabView">{lang.s_content_label} *</label>
                                    <InfoRoundButton message={lang.used_to_configure_prefix_suffix_and_incremental_next_number_for_assetid_tooltip}></InfoRoundButton>
                                    <DropDownList
                                        style={{ backgroundColor: 'white' }}
                                        data={content.filter((x) => x.MediaCategoryType.MediaCategorySID == MEDIACATEGORIES.Season)}
                                        name="SeasonContent"
                                        textField="Description"
                                        dataItemKey="_id"
                                        value={seasonEpisodeDataItem.SeasonContent}
                                        onChange={handleCreateSeasonEpisodeChange}
                                    />
                                </div>

                                <div className='col-2'>
                                    <label htmlFor="">{lang.season_no_label} *</label>
                                    <input name="SeasonNumber" type="number" className="form-control form-control-sm" value={seasonEpisodeDataItem.SeasonNumber} onChange={(e) => handleCreateSeasonEpisodeChange(e)} min={1} />
                                </div>


                                <div className="col-2">
                                    <label htmlFor="TabView">{lang.ep_content_label} *</label>
                                    <InfoRoundButton message={lang.used_to_configure_prefix_suffix_and_incremental_next_number_for_assetid_tooltip}></InfoRoundButton>
                                    <DropDownList
                                        style={{ backgroundColor: 'white' }}
                                        data={content.filter((x) => x.MediaCategoryType.MediaCategorySID == MEDIACATEGORIES.Episode)}
                                        name="EpisodeContent"
                                        textField="Description"
                                        dataItemKey="_id"
                                        value={seasonEpisodeDataItem.EpisodeContent}
                                        onChange={handleCreateSeasonEpisodeChange}
                                    />
                                </div>

                                <div className='col-2'>
                                    <label htmlFor="">{lang.episodes_label}</label>
                                    <input name="NumberOfEpisodes" type="number" className="form-control form-control-sm" value={seasonEpisodeDataItem.NumberOfEpisodes} onChange={(e) => handleCreateSeasonEpisodeChange(e)} min={1} />
                                </div>

                                <div className="col-2">
                                    <label htmlFor="">{lang.duration_only_label} *</label>
                                    <InfoRoundButton message={lang.time_hh_mm_ss_ff_label}></InfoRoundButton>
                                    <TimePickerWithFormat
                                        className="form-control form-control-sm"
                                        name="Duration"
                                        style={{ width: '110px' }}
                                        value={seasonEpisodeDataItem.Duration}
                                        onChange={(e) => handleCreateSeasonEpisodeChange(e)}
                                    />
                                </div>
                                <div className="col-2">
                                    <label htmlFor="">{lang.series_code_label}</label>
                                    <input name="SeasonCode" type="text" className="form-control form-control-sm" value={seasonEpisodeDataItem.SeasonCode} onChange={(e) => handleCreateSeasonEpisodeChange(e)} />
                                </div>
                                {/* </div> */}
                                {/* <div className='row'> */}
                                <div className='col-1' style={{ paddingTop: "15px" }}>
                                    <AddRoundButton onClick={onAddSeasonOfSeries}></AddRoundButton>
                                </div>
                                { /* </div> */}

                                <div className='col-12 mt-2'>
                                    <Grid data={createSeasonEpisode} style={{ height: "20vh" }}>
                                        <GridColumn cell={MyCommandCell} width={"42px"} locked={true} />
                                        <GridColumn field="SeasonNumber" title={lang.season_number_column} editable={false} width={"140px"} />
                                        <GridColumn field="NumberOfEpisodes" title={lang.no_of_episodes_column} editable={false} width={"140px"} />
                                        <GridColumn field="SeasonContent.Description" title={lang.season_content_column} editable={false} width={"140px"} />
                                        <GridColumn field="EpisodeContent.Description" title={lang.episode_content_column} editable={false} width={"170px"} />
                                        <GridColumn field="Duration" title={lang.duration_column} editable={false} cell={TimeCell} width={"140px"} />
                                        <GridColumn field="SeasonCode" editable={false} width={"140px"} />
                                    </Grid>
                                </div>
                            </div>
                        </Expander>
                    </div>
                    <p className='text-muted' style={{ fontSize: '11px', position: "relative", top: "20px", left: "15px" }}>{`* ${currentUserChannels && currentUserChannels.length == 1 ? `Deal Rights will automatically be created for ${currentUserChannels[0].FullChannelName}` : "Please create deal rights before saving"}`}</p>
                </>}
            </BossDialog>
            {openImageBank && <CollectionSelection entityname={ENTITYNAME.OttPosters} closeForm={() => setOpenImageBank(!openImageBank)} setDataList={setSelectedImage} title={lang.select_image_collection_header} mode={"single"} width={"50vw"} />}
            {openSeriesSelection && <CollectionSelection entityname={ENTITYNAME.Series} closeForm={() => setOpenSeriesSelection(!openSeriesSelection)} setDataList={onSelectionSeries} title={lang.select_series_collection_header} mode={"single"} width={"50vw"} />}

            {showEditForm.Content && <ContentEditForm item={{ SID: 0 }} cancelEdit={() => setShowEditForm(false)} refresh={() => { loadcombo(true) }} filterMediaCategory={props.mediaCategory} />}
            {showTranslateForm && <LanguageTranslator onSubmit={handleLangugaeTranslate} cancelEdit={() => setShowTranslateForm(false)} />}
            {showEditForm.Genre && <GenreEditForm item={{ SID: 0 }} cancelEdit={() => setShowEditForm(false)} refresh={() => { loadcombo(true) }} />}
            {showEditForm.MediaSubCategoryType && <MediaSubCategoryTypeEditForm item={{ SID: 0 }} cancelEdit={() => setShowEditForm(false)} refresh={() => { loadcombo(true) }} />}

        </div>
    )
}

export default AddProgramWrapperForm